export default __webpack_public_path__ + "images/5721b7cbeda65161c220131d6283f3bc-valentines_header_image_mobile.webp";